import React, { useEffect, useState } from 'react'
import Student from '../../../components/Student/Student'
import { SectionHeading, Section, Button, icons, Loading, general } from 'daymap-library'
import Alert, { ALERT_TYPE } from '../../../components/Alert/Alert';
import styles from './Records.module.scss';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../../helpers/appContext';
import { useAuth } from '../../../helpers/authContext';

function Records() {
    const navigate = useNavigate();
    const { lmsFetch } = useAuth();
    const { mode } = useApp();
    const [newRecords, setNewRecords] = useState(null);
    const [currentRecords, setCurrentRecords] = useState(null);
    const { student, appState, AddState } = useApp();

    const getNewRecords = async () => {
        const [getRecords, cancel] = lmsFetch(`/lms/api/checkin/records?mode=${encodeURIComponent(mode)}&showCurrentRecordsOnly=true`);
        const records = await getRecords();
        setNewRecords(records.data);
    }

    const getCurrentRecords = async () => {
        const [getExistingRecords, cancel] = lmsFetch(`/lms/api/checkin/currentRecords?mode=${encodeURIComponent(mode)}&studentID=${student.ID}`);
        const currentRecords = await getExistingRecords();
        setCurrentRecords(currentRecords.data);
    }

    useEffect(() => {
        if (!student){ navigate('/kiosk'); return; }
        getCurrentRecords();
        getNewRecords();
    }, []);

    const onRecordClick = formId => {
        AddState("RecordLoadError", null);
        navigate(`${formId}`);
    }

    const onCurrentRecordClick = (formId, rowId) => {
        AddState("RecordLoadError", null);
        navigate(`${formId}/${rowId}`);
    }

    const onPageReturn = () => {
        AddState("RecordLoadError", null);
        navigate('/kiosk');
    }

    return (
            <div className={styles.Wrapper}>
                <Section>
                    <Student {...student} />
                </Section>
                {newRecords == null ? <Loading message="Loading Records" /> :
                <>
                    {appState.RecordLoadError && 
                        <RecordLoadError errorMessage={appState.RecordLoadError} onPageReturn={onPageReturn} />
                    }
                    {currentRecords && currentRecords.length > 0 && (
                        <div><h3>{"Current Records"}</h3>
                            <div className={styles.Records}>
                                {currentRecords && currentRecords.map(r => <Button key={r.Form.FormID} text={r.Form.Caption} onClick={() => onCurrentRecordClick(r.Form.FormID, r.Record.RowId)} large />)}
                            </div>
                        </div>
                    )}
                    <div><h3>{"New Records"}</h3></div>
                        <div className={styles.Records}>
                            {newRecords && newRecords.map(r => <Button key={r.FormID} text={r.CaptionNew || r.Caption} onClick={() => onRecordClick(r.FormID)} large />)}
                        </div>
                        <Button iconClass={icons.ICON_CSS_CLASS.Back} text="Cancel" onClick={() => {onPageReturn()}} large secondary />
                    </>
                }                
            </div>
    )
}

const RecordLoadError = ({ errorMessage, onPageReturn }) => {
    const { settings } = useAuth();
    const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => {onPageReturn()} });

    if (!(settings.KioskRedirectDelay > 0)) {
        onPageReturn();
        return "";
    }

    return (
        <Alert type={ALERT_TYPE.Error}>
            <div>{errorMessage}</div>
            <div>Returning to kiosk in {secondsTilRedirect} seconds.</div>
        </Alert>
    )
}

export default Records